import {ChatMessage, ParticipantKey} from "@/app-modules/messages/chat/types";
import {Agent} from "./Agent";
import {AccountProfileContextTrait, getAskWyzeChatUrl} from "../../libwyze-shared/types";
import {AskWyzeContent, AskWyzeRequest, AskWyzeResponse} from "../../libwyze-common/api/types";
import {BaseApp} from "../../shared/BaseApp";


export class AskWyzeAgent extends Agent {

  constructor(readonly myParticipantKey: ParticipantKey) {
    super();
  }

  async chat(messages: ChatMessage[]): Promise<string> {
    let maxUserHistory = 2;
    let lastUserMessageIndex = messages.length;
    for (let i = messages.length - 1; i >= 0; i--) {
      if (messages[i].from.id === this.myParticipantKey.id) {
        lastUserMessageIndex = i;
        if (--maxUserHistory <= 0) {
          break;
        }
      }
    }
    const practiceId = BaseApp.CONTEXT.getTrait<AccountProfileContextTrait>().getPracticePageId();
    const response = await fetch(getAskWyzeChatUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        practiceId,
        history: messages.slice(lastUserMessageIndex).map(message => {
          return {
            role: message.from.id !== this.myParticipantKey.id ? "assistant" : "user",
            text: message.text,
          } as AskWyzeContent;
        }),
      } as AskWyzeRequest)
    }).then(res => res.json()) as AskWyzeResponse;
    if (response.status.code !== 200) {
      throw new Error("Error fetching chat");
    }
    return response.response.content.text;
  }
}